import { render } from "./LoanCarousel.vue?vue&type=template&id=13cbb48e"
import script from "./LoanCarousel.vue?vue&type=script&lang=js"
export * from "./LoanCarousel.vue?vue&type=script&lang=js"

import "./LoanCarousel.vue?vue&type=style&index=0&id=13cbb48e&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__